import { useState } from "react";
import {
  Button, Paper, Chip, Box
} from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";

export default function FileUploader({ files = [], setFiles, multiple = false }) {

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    if (multiple) {
      setFiles(prev => [...prev, ...selectedFiles]);
    } else {
      setFiles(selectedFiles[0] || null);
    }
  };

  const handleRemoveFile = (index) => {
    if (multiple) {
      setFiles(prev => prev.filter((_, i) => i !== index));
    } else {
      setFiles(null);
    }
  };

  return (
    <Paper
      variant="outlined"
      sx={{
        p: 2,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "12px",
        gap: 2
      }}
    >
      <input
        type="file"
        id="upload-file"
        multiple={multiple}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
      <label htmlFor="upload-file">
        <Button
          variant="text"
          component="span"
          startIcon={<UploadFileIcon />}
        >
          {multiple ? "Agregar fotos" : "Cambiar foto"}
        </Button>
      </label>

      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'center' }}>
        {multiple && Array.isArray(files) ? (
          files.map((file, index) => (
            <Chip
              key={index}
              label={file.name}
              onDelete={() => handleRemoveFile(index)}
            />
          ))
        ) : (
          files && (
            <Chip
              label={files.name}
              onDelete={() => handleRemoveFile()}
            />
          )
        )}
      </Box>
    </Paper>
  );
}
